module.exports = __webpack_public_path__ + "static/media/ConferencesVision1.89218d89.PNG";